import React from "react";

import { resourceTypes } from "../../../utils/CommonFunctions";

import styles from "../../../styles/sass/searchresult.module.scss";

const calendarSVG = "/assets/images/calendar.svg";

const PlanItem = (props = {}) => {
  const { resource = {}, filter } = props;

  const mFilter = filter && JSON.parse(filter);
  const resource_type = mFilter?.type;
  // const resType = resourceTypes[resource_type];
  const plans = resource?.plan;

  return plans?.map?.((plan, pIndex) => (
    <div className={styles["plan"]} key={pIndex}>
      <div className={styles["details"]}>
        <h3> {plan?.name}</h3>
        {resource_type?.includes?.("desk") && (
          <div className={styles["d_i"]}>
            <p>Seat No</p>
            <span>
              {resource?.items.map(
                (item, i) =>
                  `${item?.seat_no}${
                    resource?.items?.length - 1 > i ? ", " : ""
                  }`
              )}
            </span>
          </div>
        )}
        {plan?.resource_id && (
          <div className={styles["d_i"]}>
            <p>Area</p>
            <span>{plan?.resource_id?.name}</span>
          </div>
        )}
        <div className={styles["price"]}>
          <p>
            {`£ ${parseFloat(plan?.dynamic_price?.discounted_net).toFixed(2)}`}{" "}
            <del>{`£ ${parseFloat(plan?.dynamic_price?.net).toFixed(2)}`}</del>
          </p>
          <p>
            <img src={calendarSVG} alt="location-logo"></img>
            <span className={styles["bold"]}>{plan?.tenure} days</span>
          </p>
        </div>
        <a
          className={styles["plan-btn"]}
          onClick={() => props.onBookNow?.(resource?._id, plan?._id)}
        >
          SELECT THIS PLAN
        </a>
      </div>
    </div>
  ));
};

export default React.memo(PlanItem);
